import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ErrorTransformerService } from '@app/shared/services/error-transformer.service';
import { ErrorDescription } from '@app/utils/error/error-description';
import { PortalError } from '@app/utils/error/portal-error';

@Component({
  selector: 'portal-error-alert',
  templateUrl: './error-alert.component.html',
  styleUrls: ['./error-alert.component.scss'],
  standalone: false,
})
export class ErrorAlertComponent implements OnChanges {
  @Input()
  alertClass: string = '';

  @Input()
  collapsible: boolean = true;

  @Input()
  dismissible: boolean = false;

  @Input()
  error: PortalError | ErrorDescription;

  @Input()
  showId: boolean = true;

  hasError: boolean = false;

  /**
   * Collapsed by default
   */
  isCollapsed: boolean = true;

  errorDescription: ErrorDescription | null = null;
  responseIsString: boolean = false;

  constructor(private errorTransformService: ErrorTransformerService) {}

  ngOnChanges(changes: SimpleChanges): void {
    const errorChange = changes.error;

    this.hasError = errorChange?.currentValue != null;

    if (this.hasError) {
      let error = errorChange.currentValue;

      if ('title' in error && 'details' in error) {
        this.errorDescription = error;
      } else {
        this.errorDescription = this.errorTransformService.describeError(error);
      }

      this.responseIsString = typeof error.response === 'string';
    }
  }

  toggleCollapse() {
    if (this.collapsible === true) {
      this.isCollapsed = !this.isCollapsed;
    }
  }
}
